import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Card from "../UI/Card";
import Text from "../UI/Text";
import Title from "../UI/Title.tsx";
import PriorityActionItem from "../Dashboard/PriorityActions/PriorityActionItem";
import SnoozeDialog from "../Dashboard/PriorityActions/SnoozeDialog";
import {
  TYPE_CONFIG,
  isSnoozed,
} from "../Dashboard/PriorityActions/priorityActionConfig";
import usePriorityActions from "../../hooks/use-priority-actions";
import type { PriorityAction } from "../../models/priorityAction";
import type { Tenant } from "../../models/tenant";
import styles from "./TenantActionsPrioritaires.module.css";

interface TenantActionsPrioritairesProps {
  tenant: Tenant;
}

export default function TenantActionsPrioritaires({
  tenant,
}: TenantActionsPrioritairesProps) {
  const { actions, snoozeAction, archiveAction } = usePriorityActions();
  const [snoozeTarget, setSnoozeTarget] = useState<PriorityAction | null>(null);
  const [, setSearchParams] = useSearchParams();

  function openCautionModal() {
    setSearchParams((params) => {
      const newParams = new URLSearchParams(params);
      newParams.set("tab-tenant-show", "actions");
      newParams.set("action", "caution");
      return newParams;
    });
  }

  const tenantActions = actions.filter(
    (action) => action.id_tenant === tenant.id && !isSnoozed(action.remind_at),
  );

  return (
    <Card>
      <Title variant="deca" weight="bold" className={styles.title}>
        Mes actions prioritaires
      </Title>
      {tenantActions.length === 0 && (
        <Text variant="deci">Aucune action prioritaire</Text>
      )}
      <div className={styles.list}>
        {tenantActions.map((action) => (
          <PriorityActionItem
            key={action.id}
            icon={(TYPE_CONFIG[action.type] ?? TYPE_CONFIG.manual).icon}
            title={action.title}
            subtitle={action.description ?? undefined}
            onAction={
              action.type === "cautionnement" ? openCautionModal : undefined
            }
            onSnooze={() => setSnoozeTarget(action)}
            onDelete={() => archiveAction(action.id)}
            deleteTooltip="Archiver"
          />
        ))}
      </div>
      <SnoozeDialog
        action={snoozeTarget}
        onOpenChange={(open) => !open && setSnoozeTarget(null)}
        onSnooze={snoozeAction}
      />
    </Card>
  );
}
